import { createSlice } from '@reduxjs/toolkit';
import { IDLE_STATUS, LOADING_STATUS } from '../status';

const initialState = {
  status: IDLE_STATUS,
  mode: {}, 
  model: {},
};

const slice = createSlice({
  name: 'vinculoSolicitacaoPagamentoDespesa',
  initialState,
  reducers: {
    loading: (state) => {
      state.status = LOADING_STATUS;
    },
    resetStatus: (state) => {
      state.status = IDLE_STATUS;
    },
    setModel: (state, action) => {
      state.model = action.payload;
    },
    resetModel: (state) => {
      state.model = {};
    },
  },
});

export const vinculoSolicitacaoPagamentoDespesaActions = slice.actions;

export const vinculoSolicitacaoPagamentoDespesaSelectors = {
  selectStatus: (state) => state.vinculoSolicitacaoPagamentoDespesa.status,
  selectModel: (state) => state.vinculoSolicitacaoPagamentoDespesa.model,
};

export default slice.reducer;